// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2YtMc","container":"styles_container__3fR5m","title":"styles_title__1oVZR","wrapper":"styles_wrapper__x9qgH","answer":"styles_answer__1YPa5"};